import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';
import { Money } from '@dreryk/money-common-api';

import { TranslatableText } from '@dreryk/react-common';

import { AdvancePaymentShareOnlinePaymentLinkToPatientShowModalEventInterceptor } from '../interceptors/settlement/underpayment/AdvancePaymentShareOnlinePaymentLinkToPatientShowModalEventInterceptor';

import { AdvancePaymentActionTrigger, AdvancePaymentActionVariant } from './AdvancePaymentActionTrigger';

type AdvancePaymentIssueUnderpaymentActionLinkProps = {
   label: TranslatableText;
   appointmentId: AppointmentId;
   onlinePaymentId: string;
   requiredAmount: Money;
   variant?: AdvancePaymentActionVariant;
};
export const AdvancePaymentIssueUnderpaymentActionLink = (
   props: AdvancePaymentIssueUnderpaymentActionLinkProps
): JSX.Element => (
   <AdvancePaymentShareOnlinePaymentLinkToPatientShowModalEventInterceptor
      appointmentId={props.appointmentId}
      requiredAmount={props.requiredAmount}
      onlinePaymentId={props.onlinePaymentId}
   >
      <AdvancePaymentActionTrigger
         variant={props.variant ?? 'link'}
         testId={'shareLinkToUnderpayment'}
         label={props.label}
      />
   </AdvancePaymentShareOnlinePaymentLinkToPatientShowModalEventInterceptor>
);
